import { render, staticRenderFns } from "./EditUserDetail.vue?vue&type=template&id=74d236be"
import script from "./EditUserDetail.vue?vue&type=script&lang=js"
export * from "./EditUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports